import React from 'react';
import './widgets.css';

/**
 * StatusCard — generic status/progress/capabilities display.
 *
 * Handles widgetTypes: status, progress, capabilities
 *
 * Uses the same ChatKit Card children structure.
 */
function StatusCard({ data, widgetType }) {
  const children = data.children || [];
  const statusText = data.status?.text || 'Status';

  let headerClass = 'widget-header-info';
  if (widgetType === 'status') headerClass = 'widget-header-neutral';
  if (widgetType === 'progress') headerClass = 'widget-header-warning';
  if (widgetType === 'capabilities') headerClass = 'widget-header-ai';

  return (
    <div className="widget-card">
      <div className={`widget-card-status-header ${headerClass}`}>
        <span className="widget-status-dot" />
        <span className="widget-status-text">{statusText}</span>
      </div>

      <div className="widget-card-content">
        {children.map((child, i) => {
          switch (child.type) {
            case 'Title':
              return <h4 key={i} className="widget-card-title">{child.value}</h4>;
            case 'Badge':
              return (
                <span key={i} className={`widget-badge widget-badge-${child.color || 'primary'}`}>
                  {child.label}
                </span>
              );
            case 'Text':
              return (
                <p key={i} className={`widget-text ${child.weight === 'semibold' ? 'widget-text-bold' : ''}`}>
                  {child.value}
                </p>
              );
            case 'Caption':
              return <p key={i} className="widget-caption">{child.value}</p>;
            case 'Divider':
              return <hr key={i} className="widget-divider" />;
            case 'Spacer':
              return <div key={i} className="widget-spacer" />;
            default:
              return null;
          }
        })}
      </div>
    </div>
  );
}

export default StatusCard;
